import styled from "styled-components";
import {size} from "../../helpers/breakpoints";

export const Container = styled.div`
  width: 100vw;
  min-height: 100vh;
  padding: 3rem 0;
  
  @media only screen and (max-width: ${size.xl}) {
    padding: 0;
  }
`;

export const AuthBody = styled.div`
  width: 100%;
  height: 100%;
  -webkit-box-shadow: 0 0 20px 4px rgba(35,35,35,0.25);
  box-shadow: 0 0 20px 4px rgba(35,35,35,0.25);
  border-radius: 8px;
  overflow: hidden;

  @media only screen and (max-width: ${size.xl}) {
    margin: 0;
  }
`;

export const LeftSide = styled.div`
  padding: 2rem 3rem 0;
  background-color: var(--login-bg-color);
  height: 100%;

  @media only screen and (max-width: ${size.xl}) {
    border-radius: 0 0 30px 30px;
    padding: .5rem 1rem 0;
    height: 35vh;
  }
`;

export const RightSide = styled.div`
  background-color: var(--main-color);
  padding: 2rem 3rem 0;

  @media only screen and (max-width: ${size.xl}) {
    min-height: 65vh;
    padding: .5rem 2rem 0;
  }
`;

export const AuthImage = styled.img`
  width: 100%;
  height: calc(100% - 52px);
  object-fit: contain;
`;
